/**
 * Resumen IA del expediente.
 *
 * El backend decide qué variante devuelve a partir del rol de quien pregunta:
 * desde aquí no se pide una en concreto, y no se debe intentar. Un `company`
 * recibe la suya y nunca la interna.
 */
import apiClient from './api/client';

/** @returns {Promise<object>} la variante que corresponde al usuario */
export async function getExpedientSummary(expedientId) {
  const { data } = await apiClient.get(`/expedients/${expedientId}/summary`);
  return data;
}

/** Regenera el resumen. Solo disponible para roles internos. */
export async function refreshExpedientSummary(expedientId) {
  const { data } = await apiClient.post(`/expedients/${expedientId}/summary/refresh`);
  return data;
}

/** El "no cuadra": deja rastro y regenera. Solo roles internos. */
export async function reportExpedientSummary(expedientId, reason) {
  const { data } = await apiClient.post(`/expedients/${expedientId}/summary/feedback`, { reason });
  return data;
}
